import { Title, Text, Button, Container } from '@mantine/core';
import { Dots } from './Dots';
import classes from './Hero.module.css';

export function HeroText() {
  return (
    <Container className={classes.wrapper} size={1400}>
      <Dots className={classes.dots} style={{ left: 0, top: 0 }} />
      <Dots className={classes.dots} style={{ left: 60, top: 0 }} />
      <Dots className={classes.dots} style={{ left: 0, top: 140 }} />
      <Dots className={classes.dots} style={{ right: 0, top: 60 }} />

      <div className={classes.inner}>
        <Title className={classes.title}>
        Empower your{' '}
          <Text component="span" className={classes.highlight} inherit>
          Tech Journey
          </Text>{' '}
          with<br/> cutting-edge products
        </Title>

        <Container p={0} size={600}>
          <Text size="lg" c="dimmed" className={classes.description}>
          Embrace innovation, explore possibilities, and elevate your tech journey with us!
          </Text>
        </Container>

        <div className={classes.controls}>
          <Button  className={classes.herob1} size="md" variant="default" color="gray">
         <a href='https://t.me/careercredentials'> Join our community</a>
          </Button>
          <Button className={classes.herob2} size="md">
          <a href="#code-playground">Explore Our Products</a>
          </Button>
        </div>
      </div>
    </Container>
  );
}